module.exports = __webpack_public_path__ + "static/media/atlantis.d443bbc7.png";